import Enum from '@/modules/core/app/helpers/Enum';

export class OpenAIModel extends Enum {
  key!: string;
  value!: string;

  static GPT_3_5_TURBO = {
    key: 'gpt-3.5-turbo',
    get value(): string {
      return 'GPT-3.5 Turbo';
    }
  };

  static GPT_4_TURBO = {
    key: 'gpt-4-turbo',
    get value(): string {
      return 'GPT-4 Turbo';
    }
  };

  static GPT_4_O = {
    key: 'gpt-4o',
    get value(): string {
      return 'GPT-4o';
    }
  };

  static GPT_4_O_MINI = {
    key: 'gpt-4o-mini',
    get value(): string {
      return 'GPT-4o Mini';
    }
  };

  static GPT_4_1 = {
    key: 'gpt-4.1',
    get value(): string {
      return 'GPT-4.1';
    }
  };

  static GPT_4_1_MINI = {
    key: 'gpt-4.1-mini',
    get value(): string {
      return 'GPT-4.1 Mini';
    }
  };

  static GPT_4_1_NANO = {
    key: 'gpt-4.1-nano',
    get value(): string {
      return 'GPT-4.1 Nano';
    }
  };

  static O_4_MINI = {
    key: 'o4-mini',
    get value(): string {
      return 'o4 Mini';
    }
  };

  static O_3 = {
    key: 'o3',
    get value(): string {
      return 'o3';
    }
  };

  static GPT_5 = {
    key: 'gpt-5',
    get value(): string {
      return 'GPT-5';
    }
  };

  static GPT_5_MINI = {
    key: 'gpt-5-mini',
    get value(): string {
      return 'GPT-5 Mini';
    }
  };

  static GPT_5_NANO = {
    key: 'gpt-5-nano',
    get value(): string {
      return 'GPT-5 Nano';
    }
  };

  static GPT_5_2 = {
    key: 'gpt-5.2',
    get value(): string {
      return 'GPT-5.2';
    }
  };

  static GPT_5_4 = {
    key: 'gpt-5.4',
    get value(): string {
      return 'GPT-5.4';
    }
  };

  static GPT_5_4_MINI = {
    key: 'gpt-5.4-mini',
    get value(): string {
      return 'GPT-5.4 Mini';
    }
  };

  static GPT_5_4_NANO = {
    key: 'gpt-5.4-nano',
    get value(): string {
      return 'GPT-5.4 Nano';
    }
  };

  static GPT_5_5 = {
    key: 'gpt-5.5',
    get value(): string {
      return 'GPT-5.5';
    }
  };

  static GPT_5_6 = {
    key: 'gpt-5.6',
    get value(): string {
      return 'GPT-5.6';
    }
  };

  static GPT_5_6_SOL = {
    key: 'gpt-5.6-sol',
    get value(): string {
      return 'GPT-5.6 Sol';
    }
  };

  static GPT_5_6_TERRA = {
    key: 'gpt-5.6-terra',
    get value(): string {
      return 'GPT-5.6 Terra';
    }
  };

  static GPT_5_6_LUNA = {
    key: 'gpt-5.6-luna',
    get value(): string {
      return 'GPT-5.6 Luna';
    }
  };
}
